export const PolygonContract = {
  MUMBAI: {
    SONG: '0x7fAfB9eB1283c1655D4447d742a93Cd9f8ec3688',
    STEM: '0xDBd409Cb453Da101aa0Ca178a54526E2DBacC14a',
    SAMPLE: '0xDBd409Cb453Da101aa0Ca178a54526E2DBacC14a'
  },
  MAINNET: {
    SONG: '',
    STEM: '',
    SAMPLE: ''
  }
}
